import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {BoosterService} from "../services/booster.service";

@Injectable()
export class BenchmarkResolver implements Resolve<any> {

  constructor(
    private _boosterService: BoosterService,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    return new Promise((resolve: Function) => {
      resolve(true);

    });
  }

}
